export default {"src":"/_next/static/media/email-icon.4f993ce2.svg","height":19,"width":24,"blurWidth":0,"blurHeight":0};